// Vendor imports
const cookie = require('js-cookie')

// Action types

const DISMISS = 'LIGHTWEIGHT_ENGAGEMENT_TUTORIAL_DISMISS'

// Action dispatchers

function dismiss() {
  return function (dispatch) {
    dispatch({ type: DISMISS })
    cookie.remove('ftu_lwe')
  }
}

// Exports

module.exports = {
  // Action types
  DISMISS,
  // Action dispatchers
  dismiss
}
